import React from 'react';

import AFFILIATION_DISCLAIMER from 'components/users/syndication/affiliation_disclaimer';
import PartnerCard from 'components/users/syndication/partner_card';
import RequestForm from 'components/users/syndication/request_form';

import type { SyndicationPartner, UserProfile } from 'components/users/types';

type Props = Pick<UserProfile, 'syndication'>;

function inPairs(partners: SyndicationPartner[]): SyndicationPartner[][] {
  const pairs: SyndicationPartner[][] = [];
  for (let i = 0; i < partners.length; i += 2) {
    pairs.push(partners.slice(i, i + 2));
  }
  return pairs;
}

export default function SyndicationTab({ syndication }: Props) {
  const { partners, unaffiliatedPartners, hasEmailSyndication, propertyTypes, paths } = syndication;

  function renderRows(rowPartners: SyndicationPartner[]) {
    return inPairs(rowPartners).map(pair => (
      <div className="row" key={pair.map(partner => partner.id).join('-')}>
        {pair.map(partner => (
          <PartnerCard key={partner.id} partner={partner} propertyTypes={propertyTypes} />
        ))}
      </div>
    ));
  }

  return (
    <>
      <h5 className="mb-2">The Buildout Syndication Network</h5>

      <div>
        {renderRows(partners)}
        <hr />
      </div>

      {hasEmailSyndication && (
        <>
          <div className="d-flex justify-content-between">
            <h5 className="mt-8 mb-2">Unaffiliated Channels</h5>
          </div>

          <div className="mb-4 fst-italic">Please note that {AFFILIATION_DISCLAIMER}</div>
        </>
      )}

      <div>
        {hasEmailSyndication && (
          <>
            {renderRows(unaffiliatedPartners)}
            <hr />
          </>
        )}

        <RequestForm submitPartnerRequest={paths.submitPartnerRequest} />
      </div>
    </>
  );
}
